/* eslint-disable react-hooks/exhaustive-deps */
/**
 * B100223 配送ルート割付マスタ出力
 */
import { Box } from "@mui/material";
import {
  B100223ExcelRequest,
  B100223GetExcel,
  catchFileError,
} from "clients/rest";
import {
  msgState,
  SConfirmDialog,
  SFileButton,
  SFrame,
  SLabel,
  SText,
  STextField,
} from "components";
import { getClientMessage } from "messages";
import { labels } from "messages/labels";
import { useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { download } from "services";
import { focusState, useFocus } from "states";

// 呼び出し時のプロパティ
type Props = Partial<{}>;

// コンポーネントで設定されるフィールドの型を定義する
type Fields = Partial<{
  haisorouteNoFrom: string;
  haisorouteNoTo: string;
}>;

// フィールドの初期値を設定する。
const defaultFields: Fields = {
  haisorouteNoFrom: "",
  haisorouteNoTo: "",
};

const focusId = "B100223";

export const B100223 = (props: Props) => {
  useFocus(focusId);
  return <Page {...props} />;
};

const Page = (props: Props) => {
  // 状態管理の初期設定
  // フォーム関数
  const methods = useForm<Fields>({
    mode: "onBlur",
    defaultValues: defaultFields,
  });
  // フォーカス設定
  const { focus, register } = useRecoilValue(focusState(focusId));
  // 画面遷移
  const navigate = useNavigate();
  // エラー表示
  const setMsg = useSetRecoilState(msgState);

  // 初期表示イベント
  useEffect(() => {
    // 初回フォーカス先
    focus(1);
  }, []);

  // EXCELボタン押下時
  const handleClickExcelButton = () => {
    const fields = methods.getValues();

    const param: B100223ExcelRequest = {
      haisorouteNoFrom: fields.haisorouteNoFrom!,
      haisorouteNoTo: fields.haisorouteNoTo!,
    };

    B100223GetExcel(param)
      .then((response) => {
        download(response);
        setMsg(getClientMessage("B100223_001"));
      })
      .catch((reason) => {
        catchFileError(reason, navigate, setMsg);
      });
  };

  // レイアウト設定
  return (
    <FormProvider {...methods}>
      <SFrame
        title="配送ルート割付マスタ出力"
        gridTemplateColumns="8rem 10rem 1rem 10rem 5rem"
      >
        <SText gridColumn="span 5">　</SText>

        <SLabel>配送ルート番号</SLabel>
        <STextField name="haisorouteNoFrom" size={10} {...register(1)} />
        <SText>～</SText>
        <STextField name="haisorouteNoTo" size={10} {...register(2)} />
        <Box />

        <SText gridColumn="span 3">　</SText>
        <SText gridColumn="span 3">　</SText>
        <SText gridColumn="span 3">　</SText>
        <SText gridColumn="span 3">　</SText>
        <SText gridColumn="span 3">　</SText>
        <SText gridColumn="span 3">　</SText>

        <Box gridColumn="span 3" />
        <SFileButton
          label={labels.buttons.excel}
          align="right"
          {...register(3)}
          dialog={
            <SConfirmDialog
              title="配送ルート割付マスタ出力"
              msg={labels.dialog.masterExcelConfirmMessage}
            />
          }
          dialogAction="confirm"
          handleSubmit={handleClickExcelButton}
        />
      </SFrame>
    </FormProvider>
  );
};
